import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import ogImage from '../assets/PricingOgImage.png'

import Addons from './components/Addons'
import ComparePlans from './components/ComparePlans'
import Faq from './components/Faq'
import GettingStarted from './components/GettingStarted'
import Hero from './components/Hero'
import ImplementationOptions from './components/ImplementationOptions'
import LogoCarousel from './components/LogoCarousel'
import PlansCards from './components/PlansCards'
import OtherOptions from './components/OtherOptions'

const PricingCustomerDataPlatform = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Customer Data Platform Pricing | Twilio Segment"
        pageDescription="Unlock the potential of your engineering, marketing, and product teams with our customer data platform. Discover pricing options and learn more from Twilio Segment."
        pageOG={ogImage}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <PlansCards />
          <LogoCarousel />
          <ImplementationOptions />
          <ComparePlans />
          <Addons />
          <OtherOptions />
          <Faq />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default PricingCustomerDataPlatform
